const errorData = ref<{
  error: Error
  instance: any
  info: string
} | null>(null)

function captureError (error: Error, instance, info) {
  errorData.value = {
    error,
    instance,
    info
  }
  return false // 后续错误发送到全局处理
}

const isNetworkError = (error: Error) => {
  // 过滤网络请求错误
  return error instanceof TypeError && (
    error.message.includes('Failed to fetch') ||
    error.message.includes('NetworkError') ||
    error.message.includes('网络请求失败') ||
    error.message.includes('Network request failed')
  )
}

window.addEventListener('error', (e) => {
  if (e.target instanceof HTMLElement) // 如果是资源加载错误，不进行处理
    return

  if (e.error && isNetworkError(e.error)) return

  captureError({name: 'error', ...e}, null, null)
  return true
}, true)

// window.addEventListener('unhandledrejection', (e) => {
//   if (isNetworkError(e.reason)) return
    
//   if (e.reason instanceof DOMException && e.reason.name === 'AbortError') {
//     // console.error('AbortError：', e)
//     // 捕获到媒体播放中断错误
//     return;
//   }
  
//   if (e.reason == 'Uid or passwd is empty') {
//     return
//   }

//   captureError({name: 'unhandledrejection', message: e.reason}, null, null)
//   return true
// }, true)

export function useErrorBoundary() {
  return {
    error: errorData,
    captureError
  }
}
